"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelationExtra = exports.RelationAction = exports.RelationKind = exports.RelationLink = exports.RelationCardinality = exports.Entity = exports.entityExtraProps = exports.entityExtraKeys = exports.EntityExtra = exports.EntityStats = exports.EntityKind = exports.Attribute = exports.attributeExtraProps = exports.attributeExtraKeys = exports.AttributeExtra = exports.AttributeStats = exports.AttributeTypeParsed = exports.AttributeTypeKind = exports.PrimaryKey = exports.Index = exports.Check = exports.indexExtraKeys = exports.IndexExtra = exports.IndexStats = exports.TypeRef = exports.RelationRef = exports.ConstraintRef = exports.AttributesRef = exports.AttributeRef = exports.EntityRef = exports.Namespace = exports.Extra = exports.RelationId = exports.TypeId = exports.ConstraintId = exports.AttributesId = exports.AttributeId = exports.AttributePathId = exports.EntityId = exports.NamespaceId = exports.TypeName = exports.ConstraintName = exports.AttributeValue = exports.AttributeType = exports.AttributePath = exports.AttributeName = exports.EntityName = exports.SchemaName = exports.CatalogName = exports.DatabaseName = void 0;
exports.DatabaseSchema = exports.Database = exports.databaseExtraKeys = exports.DatabaseExtra = exports.DatabaseStats = exports.DatabaseKind = exports.Type = exports.typeExtraProps = exports.typeExtraKeys = exports.TypeExtra = exports.Relation = exports.relationExtraProps = exports.relationExtraKeys = void 0;
const zod_1 = require("zod");
const zod_to_json_schema_1 = __importDefault(require("zod-to-json-schema"));
const common_1 = require("./common");
// read this file from bottom to the top, to have a top-down read ^^
// TODO:
//   - function to check Database consistency (no relation to non-existing entity, etc)
//   - function to diff two Database
//   - convert Database to Project and the reverse
exports.DatabaseName = zod_1.z.string();
exports.CatalogName = zod_1.z.string();
exports.SchemaName = zod_1.z.string();
exports.EntityName = zod_1.z.string();
exports.AttributeName = zod_1.z.string();
exports.AttributePath = exports.AttributeName.array();
exports.AttributeType = zod_1.z.string();
// FIXME: remove unknown from AttributeValue
exports.AttributeValue = zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean(), zod_1.z.date(), zod_1.z.null(), zod_1.z.unknown()]);
exports.ConstraintName = zod_1.z.string();
exports.TypeName = zod_1.z.string();
exports.NamespaceId = zod_1.z.string(); // serialized Namespace, ex: 'database.catalog.schema', 'public'
exports.EntityId = zod_1.z.string(); // serialized EntityRef (entity name with namespace), ex: 'database.catalog.schema.table', 'public.users'
exports.AttributePathId = zod_1.z.string(); // serialized AttributePath for nested attributes: ex: 'attribute.nested_attribute', 'payload.address.street'
exports.AttributeId = zod_1.z.string(); // serialized AttributeRef (EntityId with AttributePathId), ex: 'table(id)', 'd.c.s.events(payload.address.no)'
exports.AttributesId = zod_1.z.string(); // serialized AttributesRef (EntityId with list of AttributePathId), ex: 'table(id, email)', 'd.c.s.events(payload.address.no, payload.address.street)'
exports.ConstraintId = zod_1.z.string(); // serialized ConstraintRef (EntityId with ConstraintName), ex: 'table(table_pk)', 'd.c.s.events(event_created_by_fk)'
exports.TypeId = zod_1.z.string(); // serialized TypeRef (type name with namespace), ex: 'public.post_status'
exports.RelationId = zod_1.z.string(); // serialized RelationRef link, ex: 'posts(author)->users(id)'
exports.Extra = zod_1.z.record(zod_1.z.any());
exports.Namespace = zod_1.z.object({
    database: exports.DatabaseName,
    catalog: exports.CatalogName,
    schema: exports.SchemaName,
}).partial().strict();
exports.EntityRef = exports.Namespace.extend({ entity: exports.EntityName }).strict();
exports.AttributeRef = exports.EntityRef.extend({ attribute: exports.AttributePath }).strict();
exports.AttributesRef = exports.EntityRef.extend({ attrs: exports.AttributePath.array() }).strict();
exports.ConstraintRef = exports.EntityRef.extend({ constraint: exports.ConstraintName }).strict();
exports.RelationRef = zod_1.z.object({ src: exports.AttributesRef, ref: exports.AttributesRef }).strict();
exports.TypeRef = exports.Namespace.extend({ type: exports.TypeName }).strict();
exports.IndexStats = zod_1.z.object({
    size: zod_1.z.number().optional(), // used bytes
    scans: zod_1.z.number().optional(), // number of index scans
    scansLast: common_1.DateTime.optional(), // last index scan
}).strict();
exports.IndexExtra = exports.Extra.and(zod_1.z.object({
    line: zod_1.z.number().optional(),
    statement: zod_1.z.number().optional(),
}));
exports.indexExtraKeys = ['line', 'statement'];
exports.Check = zod_1.z.object({
    name: exports.ConstraintName.optional(),
    attrs: exports.AttributePath.array(),
    predicate: zod_1.z.string(),
    doc: zod_1.z.string().optional(),
    stats: exports.IndexStats.optional(),
    extra: exports.IndexExtra.optional(),
}).strict();
exports.Index = zod_1.z.object({
    name: exports.ConstraintName.optional(),
    attrs: exports.AttributePath.array(),
    unique: zod_1.z.boolean().optional(), // false when not specified
    partial: zod_1.z.string().optional(), // false when not specified
    definition: zod_1.z.string().optional(),
    doc: zod_1.z.string().optional(),
    stats: exports.IndexStats.optional(),
    extra: exports.IndexExtra.optional(),
}).strict();
exports.PrimaryKey = zod_1.z.object({
    name: exports.ConstraintName.optional(),
    attrs: exports.AttributePath.array(),
    doc: zod_1.z.string().optional(),
    stats: exports.IndexStats.optional(),
    extra: exports.IndexExtra.optional(),
}).strict();
exports.AttributeTypeKind = zod_1.z.enum(['string', 'int', 'float', 'bool', 'date', 'time', 'instant', 'period', 'binary', 'uuid', 'json', 'xml', 'array', 'unknown']);
exports.AttributeTypeParsed = zod_1.z.object({
    full: zod_1.z.string(),
    kind: exports.AttributeTypeKind,
    size: zod_1.z.number().optional(),
    variable: zod_1.z.boolean().optional(),
    encoding: zod_1.z.string().optional(),
    array: zod_1.z.boolean().optional(),
}).strict();
exports.AttributeStats = zod_1.z.object({
    nulls: zod_1.z.number().optional(), // percentage of nulls, between 0 and 1
    bytesAvg: zod_1.z.number().optional(), // average bytes for a value
    cardinality: zod_1.z.number().optional(), // number of different values
    commonValues: zod_1.z.object({
        value: exports.AttributeValue,
        freq: zod_1.z.number()
    }).strict().array().optional(),
    distinctValues: exports.AttributeValue.array().optional(),
    histogram: exports.AttributeValue.array().optional(),
    min: exports.AttributeValue.optional(),
    max: exports.AttributeValue.optional(),
}).strict();
exports.AttributeExtra = exports.Extra.and(zod_1.z.object({
    line: zod_1.z.number().optional(),
    statement: zod_1.z.number().optional(),
    autoIncrement: zod_1.z.null().optional(),
    hidden: zod_1.z.null().optional(),
    tags: zod_1.z.string().array().optional(),
    comment: zod_1.z.string().optional(), // if there is a comment in the attribute line
}));
exports.attributeExtraKeys = ['line', 'statement', 'autoIncrement', 'hidden', 'tags', 'comment'];
exports.attributeExtraProps = ['autoIncrement', 'hidden', 'tags']; // extra keys manually set in properties
exports.Attribute = zod_1.z.object({
    name: exports.AttributeName,
    type: exports.AttributeType,
    null: zod_1.z.boolean().optional(), // false when not specified
    gen: zod_1.z.boolean().optional(), // false when not specified
    default: exports.AttributeValue.optional(),
    attrs: zod_1.z.lazy(() => exports.Attribute.array().optional()),
    doc: zod_1.z.string().optional(),
    stats: exports.AttributeStats.optional(),
    extra: exports.AttributeExtra.optional(),
}).strict();
exports.EntityKind = zod_1.z.enum(['table', 'view', 'materialized view', 'foreign table']);
exports.EntityStats = zod_1.z.object({
    rows: zod_1.z.number().optional(), // number of rows
    rowsDead: zod_1.z.number().optional(), // number of dead rows
    size: zod_1.z.number().optional(), // used bytes
    sizeIdx: zod_1.z.number().optional(), // used bytes for indexes
    sizeToast: zod_1.z.number().optional(), // used bytes for toasts
    sizeToastIdx: zod_1.z.number().optional(), // used bytes for toasts indexes
    scanSeq: zod_1.z.number().optional(), // number of seq scan
    scanSeqLast: common_1.DateTime.optional(),
    scanIdx: zod_1.z.number().optional(), // number of index scan
    scanIdxLast: common_1.DateTime.optional(),
    analyzeLast: common_1.DateTime.optional(),
    analyzeLag: zod_1.z.number().optional(),
    vacuumLast: common_1.DateTime.optional(),
    vacuumLag: zod_1.z.number().optional(),
}).strict();
exports.EntityExtra = exports.Extra.and(zod_1.z.object({
    line: zod_1.z.number().optional(),
    statement: zod_1.z.number().optional(),
    alias: zod_1.z.string().optional(),
    color: zod_1.z.string().optional(),
    tags: zod_1.z.string().array().optional(),
    comment: zod_1.z.string().optional(), // if there is a comment in the entity line
}));
exports.entityExtraKeys = ['line', 'statement', 'alias', 'color', 'tags', 'comment'];
exports.entityExtraProps = ['view', 'color', 'tags']; // extra keys manually set in properties (view is set in props but stored in entity def, not extra ^^)
exports.Entity = exports.Namespace.extend({
    name: exports.EntityName,
    kind: exports.EntityKind.optional(), // 'table' when not specified
    def: zod_1.z.string().optional(), // the query definition for views
    attrs: exports.Attribute.array().optional(),
    pk: exports.PrimaryKey.optional(),
    indexes: exports.Index.array().optional(),
    checks: exports.Check.array().optional(),
    doc: zod_1.z.string().optional(),
    stats: exports.EntityStats.optional(),
    extra: exports.EntityExtra.optional(),
}).strict();
exports.RelationCardinality = zod_1.z.enum(['0', '1', 'n']);
exports.RelationLink = exports.EntityRef.extend({ attrs: exports.AttributePath.array(), cardinality: exports.RelationCardinality.optional() });
exports.RelationKind = zod_1.z.enum(['many-to-one', 'one-to-many', 'one-to-one', 'many-to-many']);
exports.RelationAction = zod_1.z.enum(['no action', 'set null', 'set default', 'cascade', 'restrict']);
exports.RelationExtra = exports.Extra.and(zod_1.z.object({
    line: zod_1.z.number().optional(),
    statement: zod_1.z.number().optional(),
    inline: zod_1.z.boolean().optional(), // when defined within the parent entity
    natural: zod_1.z.enum(['src', 'ref', 'both']).optional(), // natural join: attributes are not specified
    onUpdate: zod_1.z.union([exports.RelationAction, zod_1.z.string()]).optional(),
    onDelete: zod_1.z.union([exports.RelationAction, zod_1.z.string()]).optional(),
    srcAlias: zod_1.z.string().optional(),
    refAlias: zod_1.z.string().optional(),
    tags: zod_1.z.string().array().optional(),
    comment: zod_1.z.string().optional(), // if there is a comment in the relation line
}));
exports.relationExtraKeys = ['line', 'statement', 'inline', 'natural', 'onUpdate', 'onDelete', 'srcAlias', 'refAlias', 'tags', 'comment'];
exports.relationExtraProps = ['onUpdate', 'onDelete', 'tags']; // extra keys manually set in properties
exports.Relation = zod_1.z.object({
    name: exports.ConstraintName.optional(),
    origin: zod_1.z.enum(['fk', 'infer-name', 'infer-similar', 'infer-query', 'user']).optional(), // 'fk' when not specified
    src: exports.RelationLink,
    ref: exports.RelationLink,
    polymorphic: zod_1.z.object({ attribute: exports.AttributePath, value: exports.AttributeValue }).optional(),
    doc: zod_1.z.string().optional(),
    extra: exports.RelationExtra.optional(),
}).strict();
exports.TypeExtra = exports.Extra.and(zod_1.z.object({
    line: zod_1.z.number().optional(),
    statement: zod_1.z.number().optional(),
    inline: zod_1.z.boolean().optional(), // when defined within the parent entity
    tags: zod_1.z.string().array().optional(),
    comment: zod_1.z.string().optional(), // if there is a comment in the type line
}));
exports.typeExtraKeys = ['line', 'statement', 'inline', 'tags', 'comment'];
exports.typeExtraProps = ['tags']; // extra keys manually set in properties
exports.Type = exports.Namespace.extend({
    name: exports.TypeName,
    alias: zod_1.z.string().optional(),
    values: zod_1.z.string().array().optional(),
    attrs: exports.Attribute.array().optional(),
    definition: zod_1.z.string().optional(),
    doc: zod_1.z.string().optional(),
    extra: exports.TypeExtra.optional(),
}).strict();
exports.DatabaseKind = zod_1.z.enum(['bigquery', 'cassandra', 'couchbase', 'db2', 'elasticsearch', 'mariadb', 'mongodb', 'mysql', 'oracle', 'postgres', 'redis', 'snowflake', 'sqlite', 'sqlserver']);
exports.DatabaseStats = zod_1.z.object({
    name: exports.DatabaseName,
    kind: exports.DatabaseKind,
    version: zod_1.z.string(),
    size: zod_1.z.number(), // used bytes
    extractedAt: common_1.DateTime, // legacy, see extra.createdAt instead
    extractionDuration: common_1.Millis, // legacy, see extra.creationTimeMs instead
}).partial().strict();
exports.DatabaseExtra = exports.Extra.and(zod_1.z.object({
    source: zod_1.z.string().optional(), // what/who created this database, format: `${name} <${version}>` (version is optional, inspired by package.json author)
    createdAt: common_1.DateTime.optional(), // when it was created
    creationTimeMs: common_1.Millis.optional(), // how long it took to create it
    comments: zod_1.z.object({ line: zod_1.z.number(), comment: zod_1.z.string() }).array().optional(), // source line comments, used to generate them back
    namespaces: exports.Namespace.extend({ line: zod_1.z.number(), comment: zod_1.z.string().optional() }).array().optional(), // source namespace statements, used to generate them back
}));
exports.databaseExtraKeys = ['source', 'createdAt', 'creationTimeMs', 'comments', 'namespaces'];
exports.Database = zod_1.z.object({
    entities: exports.Entity.array().optional(),
    relations: exports.Relation.array().optional(),
    types: exports.Type.array().optional(),
    // functions: z.record(FunctionId, Function.array()).optional(),
    // procedures: z.record(ProcedureId, Procedure.array()).optional(), // parse procedures and list them on tables they use
    // triggers: z.record(TriggerId, Trigger.array()).optional(), // list triggers on tables they belong
    doc: zod_1.z.string().optional(),
    stats: exports.DatabaseStats.optional(),
    extra: exports.DatabaseExtra.optional(),
}).strict().describe('Database');
// keep it sync with backend/priv/static/aml_schema.json (see test)
exports.DatabaseSchema = (0, zod_to_json_schema_1.default)(exports.Database, {
    name: 'Database',
    definitions: {
        DatabaseName: exports.DatabaseName, CatalogName: exports.CatalogName, SchemaName: exports.SchemaName, Namespace: exports.Namespace,
        Entity: exports.Entity, EntityRef: exports.EntityRef, EntityName: exports.EntityName, EntityKind: exports.EntityKind,
        Attribute: exports.Attribute, AttributeRef: exports.AttributeRef, AttributeName: exports.AttributeName, AttributePath: exports.AttributePath, AttributeType: exports.AttributeType, AttributeValue: exports.AttributeValue,
        PrimaryKey: exports.PrimaryKey, Index: exports.Index, Check: exports.Check, ConstraintName: exports.ConstraintName,
        Relation: exports.Relation, RelationLink: exports.RelationLink, RelationCardinality: exports.RelationCardinality,
        Type: exports.Type, TypeName: exports.TypeName,
        Extra: exports.Extra, DatabaseExtra: exports.DatabaseExtra, EntityExtra: exports.EntityExtra, AttributeExtra: exports.AttributeExtra, IndexExtra: exports.IndexExtra, RelationExtra: exports.RelationExtra, TypeExtra: exports.TypeExtra
    }
});
//# sourceMappingURL=database.js.map